module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "epi"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v("‘How charmingly and effectively these foreign tags assist one in the great task of calling a spade by some other name!’")]), _vm._v(" "), _c('p', {
    staticClass: "epir"
  }, [_vm._v("Aldous Huxley, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Antic Hay")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a83e144","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Epigraph.vue
// module id = 69
// module chunks = 0